import o from "../../_virtual/t_global_breakpoint_md.js";
import l from "../../_virtual/t_global_breakpoint_lg.js";
import a from "../../_virtual/t_global_breakpoint_xl.js";
import r from "../../_virtual/t_global_breakpoint_2xl.js";
const i = {
  md: parseInt(o.value),
  lg: parseInt(l.value),
  xl: parseInt(a.value),
  "2xl": parseInt(r.value)
};
export {
  i as globalBreakpoints
};
